module.exports = __webpack_public_path__ + "static/assets/933c9eb4ee44b14c0758973d4564d095.gif";